import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class FtpService {

  
  constructor(private backendService: BackendService ) { }
  private path = '/ftp-details'; 


  saveFtpDetails(ftpdetails) {
    return this.backendService.post(this.path , ftpdetails);
    
  }

  getFtpById() {
    
    return this.backendService.get(this.path  );
  }
}
